<div class="tabs" [ngClass]="{
    'tabs--small': tabSize == 'small',
    'tabs--medium': tabSize == 'medium'
  }">
  <div class="tabs__labels">
    <span *ngFor="let tabItem of tabItems">
      <!-- Internal -->
      <a
        *ngIf="!tabItem.tab.linkExternal"
        (click)="handleTabSelect(tabItem)"
        class="tabs__label"
        [class.tabs__label--active]="isTabActive(tabItem)">
        <span>{{ tabItem.label }}</span>
      </a>
    </span>
  </div>

  <div class="tabs__content">
    <ng-content></ng-content>
  </div>
</div>
  